<app-custom-select
  [iconClass]="'text-indent-left fw-bold'"
  [options]="getFilteredList()"
  [(ngModel)]="localValue"
  [title]="getTitle()"
  (ngModelChange)="onValueChange($event)"
  [isDisabled]="isDisabled || loading || !parkingBaySectionUuid">
</app-custom-select>
